import { render, staticRenderFns } from "./MainHero.vue?vue&type=template&id=60f3ce8e&scoped=true&"
var script = {}
import style0 from "./MainHero.vue?vue&type=style&index=0&id=60f3ce8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f3ce8e",
  null
  
)

export default component.exports